import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withRouter } from "react-router";
import { fetchData, updateAPIStatus, updateWhatsappStatus } from "./actions";
import { setKilometerDriven, makeLead, setStep, showProceedButton, activateLastStep, updateLead, setLeadScore } from "../lead-form/actions";
import { setMobile } from "../../configuration/actions";
import { updateLeadSource } from "../settings/actions";
import LeadKilometerDriven from "./component";

const mapStateToProps = ({
    leadData,
    kilometersDriven,
    brands,
    user: { mobile, gaId, name, secureToken},
    settings: { leadSource },
    location: { position: { lat, lng }, pincode },
    experiments: { cashBonus },
    cities: { selectedCity },
    locationPicker: {
        locationSelectionType
    }
}) => ({
    gaId,
    name,
    leadData,
    kilometersDriven,
    brands,
    mobile,
    source: leadSource,
    lat,
    lng,
    cashBonus,
    selectedCity,
    pincode,
    locationSelectionType,
    secureToken
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
    fetchDataConnect: fetchData,
    setKilometerDrivenConnect: setKilometerDriven,
    makeLeadConnect: makeLead,
    setStepConnect: setStep,
    showProceedConnect: showProceedButton,
    setUserMobileConnect: setMobile,
    activateLastStepConnect: activateLastStep,
    updateLeadConnect: updateLead,
    updateAPIStatusConnect: updateAPIStatus,
    updateWhatsappStatusConnect: updateWhatsappStatus,
    updateLeadSourceConnect: updateLeadSource,
    setLeadScoreConnect: setLeadScore
}, dispatch);

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(LeadKilometerDriven));
